import { render, staticRenderFns } from "./PriorityManagent.vue?vue&type=template&id=8aa86320&scoped=true"
import script from "./PriorityManagent.vue?vue&type=script&setup=true&lang=js"
export * from "./PriorityManagent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PriorityManagent.vue?vue&type=style&index=0&id=8aa86320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa86320",
  null
  
)

export default component.exports